export default __webpack_public_path__ + "static/media/Milo.e69631db.png";